import Request from "../../lib/request";
import {
  IMPREST_DETAILS_API,
  IMPREST_FILTER_API,
  IMPRESTS_API,
  ITEMS_API,
  PROJECT_USERS_API,
  REQUEST_RETURN_API,
  RETURN_API,
  SEND_API,
  UPDATE_INFO_API
} from "../../constants/api";
import { PAGE, PER_PAGE, PROJECT_USER_ID } from "../../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}`,
    needToken: true
  });
};

export const getItems = (id, pageNum) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${ITEMS_API}${
      pageNum ? "?item-page=" + pageNum : ""
    }`,
    needToken: true
  });
};

export const getList = (page_number, finalFilter, perPage) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}`,
    needToken: true,
    params: {
      ...finalFilter,
      [PAGE]: page_number,
      [PER_PAGE]: perPage
    }
  });
};

export const getDetail = (id, pageNum) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPREST_DETAILS_API}${
      pageNum ? "?item-page=" + pageNum : ""
    }`,
    needToken: true,
    data: { imprest_id: id }
  });
};

export const store = data => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}`,
    needToken: true,
    data
  });
};

export const update = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}`,
    needToken: true,
    data
  });
};

export const updateInfo = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${UPDATE_INFO_API}`,
    needToken: true,
    data
  });
};

export const sendBack = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${RETURN_API}`,
    needToken: true
  });
};

export const sendRequestBack = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${REQUEST_RETURN_API}`,
    needToken: true,
    data
  });
};

export const sendForward = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${SEND_API}`,
    needToken: true
  });
};

export const remove = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}`,
    needToken: true,
    data: id
  });
};

export const detailFilter = (data, pageNum) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPREST_FILTER_API}${
      pageNum ? "?item-page=" + pageNum : ""
    }`,
    needToken: true,
    data: data
  });
};
